const TRACKING_PARAM_PAGE_TYPE = {
  checkout_signup: 'checkout_signup',
  checkout_otp: 'checkout_otp',
  checkout_id_verification: 'checkout_id_verification',
  checkout_id_verification_otp: 'checkout_id_verification_otp',
  checkout_declined_risk: 'checkout_declined_risk',
  checkout_payment_options: 'checkout_payment_options',
  checkout_payment_confirmation: 'checkout_payment_confirmation',
  checkout_thank_you: 'checkout_thank_you',
}

const DEFAULT_TRACKING_PARAMETERS = [
  'event_category',
  'event_action',
  'event_label',
  'logged_in',
  'language',
  'customer_id',
  'user_type',
  'device_type',
  'location_country',
  'page_type',
  'date_time',
  'currency_code',
  'merchant_id',
  'merchant_name',
  'merchant_country',
  'payment_type',
  'order_total_amount',
  'order_id',
  'is_referral',
  'cc_available',
  'channel',
  'equal_installment',
]

const TRACKING_CONFIGS = {
  virtual_pageview: {
    event_name: 'virtual_pageview',
    parameters: [
      'logged_in',
      'id_verified',
      'language',
      'customer_id',
      'user_type',
      'sha256_email',
      'sha256_phone_number',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'payment_type',
    ],
  },
  merchant_signup_view: {
    event_name: 'merchant_signup_view',
    event_action: 'merchant_signup_view',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_signup,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'id_verified',
      'language',
      'customer_id',
      'user_type',
      'sha256_email',
      'sha256_phone_number',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
      'landing_variant',
    ],
    fixed_data: {
      logged_in: 'no',
      id_verified: 'no',
    },
  },
  merchant_otp_view: {
    event_name: 'merchant_otp_view',
    event_action: 'merchant_otp_view',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_otp,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'id_verified',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'sha256_email',
      'sha256_phone_number',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
    ],
    fixed_data: {
      logged_in: 'no',
      id_verified: 'no',
    },
  },
  merchant_otp_success: {
    event_name: 'merchant_otp_success',
    event_action: 'merchant_otp_success',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_otp,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'id_verified',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'sha256_email',
      'sha256_phone_number',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'yes',
    },
  },
  merchant_id_verification_type: {
    event_name: 'merchant_id_verification_type',
    event_action: 'merchant_id_verification_type',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_id_verification,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'sha256_email',
      'sha256_phone_number',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'no',
    },
  },
  merchant_id_verification_learn_more_screen: {
    event_name: 'merchant_id_verification_learn_more_screen',
    event_action: 'merchant_id_verification_learn_more_screen',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_id_verification,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'sha256_email',
      'sha256_phone_number',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'no',
    },
  },
  merchant_id_verification_view: {
    event_name: 'merchant_id_verification_view',
    event_action: 'merchant_id_verification_view',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_id_verification,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'sha256_email',
      'sha256_phone_number',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'no',
    },
  },
  merchant_id_verification_click: {
    event_name: 'merchant_id_verification_click',
    event_action: 'merchant_id_verification_click',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_id_verification,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'sha256_email',
      'sha256_phone_number',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'no',
    },
  },
  merchant_id_verification_fail: {
    event_name: 'merchant_id_verification_fail',
    event_action: 'merchant_id_verification_fail',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_id_verification,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'sha256_email',
      'sha256_phone_number',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'error_message',
      'error_code',
      'order_id',
      'cc_available',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'no',
    },
  },
  merchant_id_verification_success: {
    event_name: 'merchant_id_verification_success',
    event_action: 'merchant_id_verification_success',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_id_verification,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'id_verified',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'sha256_email',
      'sha256_phone_number',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'yes',
    },
  },
  merchant_id_verification_otp_view: {
    event_name: 'merchant_id_verification_otp_view',
    event_action: 'merchant_id_verification_otp_view',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_id_verification_otp,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'sha256_email',
      'sha256_phone_number',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'no',
    },
  },
  merchant_id_verification_otp_click: {
    event_name: 'merchant_id_verification_otp_click',
    event_action: 'merchant_id_verification_otp_click',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_id_verification_otp,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'sha256_email',
      'sha256_phone_number',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'no',
    },
  },
  merchant_id_verification_nafath_popup_screen: {
    event_name: 'merchant_id_verification_nafath_popup_screen',
    event_action: 'merchant_id_verification_nafath_popup_screen',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_id_verification,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'sha256_email',
      'sha256_phone_number',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'no',
    },
  },
  merchant_id_verification_nafath_popup_click: {
    event_name: 'merchant_id_verification_nafath_popup_click',
    event_action: 'merchant_id_verification_nafath_popup_click',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_id_verification,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'sha256_email',
      'sha256_phone_number',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'no',
    },
  },
  merchant_id_verification_nafath_screen: {
    event_name: 'merchant_id_verification_nafath_screen',
    event_action: 'merchant_id_verification_nafath_screen',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_id_verification,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'sha256_email',
      'sha256_phone_number',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'no',
    },
  },
  merchant_id_verification_nafath_click: {
    event_name: 'merchant_id_verification_nafath_click',
    event_action: 'merchant_id_verification_nafath_click',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_id_verification,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'sha256_email',
      'sha256_phone_number',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'no',
    },
  },
  merchant_order_declined: {
    event_name: 'merchant_order_declined',
    event_action: 'merchant_order_declined',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_declined_risk,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'sha256_email',
      'sha256_phone_number',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'error_message',
      'error_code',
      'order_id',
      'cc_available',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'yes',
    },
  },
  merchant_payment_type_shown: {
    event_name: 'merchant_payment_type_shown',
    event_action: 'merchant_payment_type_shown',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_options,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'order_total_amount',
      'order_id',
      'cc_available',
      'channel',
      'payment_types_details',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'yes',
    },
  },
  merchant_payment_type_select: {
    event_name: 'merchant_payment_type_select',
    event_action: 'merchant_payment_type_select',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_options,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
      'channel',
      'order_downpayemnt_amount',
      'order_repayment_amount',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'yes',
    },
  },
  merchant_payment_type_return_click: {
    event_name: 'merchant_payment_type_return_click',
    event_action: 'merchant_payment_type_return_click',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_confirmation,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'is_referral',
      'cc_available',
      'channel',
      'equal_installment',
      'order_downpayemnt_amount',
      'order_repayment_amount',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'yes',
    },
  },
  merchant_payment_type_expand_click: {
    event_name: 'merchant_payment_type_expand_click',
    event_action: 'merchant_payment_type_expand_click',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_confirmation,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'error_message',
      'error_code',
      'is_referral',
      'cc_available',
      'channel',
      'equal_installment',
      'order_downpayemnt_amount',
      'order_repayment_amount',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'yes',
    },
  },
  merchant_payment_type_collapse_click: {
    event_name: 'merchant_payment_type_collapse_click',
    event_action: 'merchant_payment_type_collapse_click',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_confirmation,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'error_message',
      'error_code',
      'is_referral',
      'cc_available',
      'channel',
      'equal_installment',
      'order_downpayemnt_amount',
      'order_repayment_amount',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'yes',
    },
  },
  merchant_payment_info_view: {
    event_name: 'merchant_payment_info_view',
    event_action: 'merchant_payment_info_view',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_confirmation,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'sha256_email',
      'sha256_phone_number',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
      'is_referral',
      'equal_installment',
      'pay_the_difference_disclaimer',
    ],
    fixed_data: {
      logged_in: 'yes',
      id_verified: 'yes',
    },
  },
  merchant_payment_click: {
    event_name: 'merchant_payment_click',
    event_action: 'merchant_payment_click',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_confirmation,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'sha256_email',
      'sha256_phone_number',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
      'is_referral',
      'equal_installment',
    ],
    fixed_data: {
      logged_in: 'no',
      id_verified: 'yes',
    },
  },
  merchant_payment_fail: {
    event_name: 'merchant_payment_fail',
    event_action: 'merchant_payment_fail',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_confirmation,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'sha256_email',
      'sha256_phone_number',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'error_message',
      'error_code',
      'order_id',
      'cc_available',
      'is_referral',
      'equal_installment',
    ],
    fixed_data: {
      logged_in: 'no',
      id_verified: 'yes',
    },
  },
  merchant_payment_success: {
    event_name: 'merchant_payment_success',
    event_action: 'merchant_payment_success',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_thank_you,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'sha256_email',
      'sha256_phone_number',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'cc_available',
      'is_referral',
      'equal_installment',
    ],
    fixed_data: {
      logged_in: 'no',
      id_verified: 'yes',
    },
  },
  merchant_order_exit: {
    event_name: 'merchant_order_exit',
    event_action: 'merchant_order_exit',
    event_category: 'checkout',
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'id_verified',
      'language',
      'customer_id',
      'user_type',
      'sha256_email',
      'sha256_phone_number',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'method_of_payment',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'error_message',
      'error_code',
      'order_id',
      'cc_available',
    ],
  },
  single_checkout_landed: {
    event_name: 'single_checkout_landed',
    event_action: 'single_checkout_landed',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_options,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'is_referral',
      'cc_available',
      'channel',
      'equal_installment',
      'order_downpayemnt_amount',
      'order_repayment_amount',
    ],
    fixed_data: {
      logged_in: 'yes',
    },
  },
  paynow_popup_opened: {
    event_name: 'paynow_popup_opened',
    event_action: 'paynow_popup_opened',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_options,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'is_referral',
      'cc_available',
      'channel',
      'equal_installment',
      'order_downpayemnt_amount',
      'order_repayment_amount',
      'version',
      'session_id',
      'id_verified',
    ],
    fixed_data: {
      logged_in: 'yes',
    },
  },
  paynow_popup_closed: {
    event_name: 'paynow_popup_closed',
    event_action: 'paynow_popup_closed',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_options,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'is_referral',
      'cc_available',
      'channel',
      'equal_installment',
      'order_downpayemnt_amount',
      'order_repayment_amount',
      'duration',
      'user_action',
    ],
    fixed_data: {
      logged_in: 'yes',
    },
  },
  subscriptions_customer_clicked_activate: {
    event_name: 'subscriptions_customer_clicked_activate',
    event_action: 'subscriptions_customer_clicked_activate',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_confirmation,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'is_referral',
      'cc_available',
      'channel',
      'equal_installment',
      'order_downpayemnt_amount',
      'order_repayment_amount',
      'duration',
      'user_action',
      'platform',
      'session_id',
      'version',
    ],
    fixed_data: {
      logged_in: 'yes',
    },
  },
  subscriptions_customer_clicked_cancel: {
    event_name: 'subscriptions_customer_clicked_cancel',
    event_action: 'subscriptions_customer_clicked_cancel',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_confirmation,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'is_referral',
      'cc_available',
      'channel',
      'equal_installment',
      'order_downpayemnt_amount',
      'order_repayment_amount',
      'duration',
      'user_action',
      'platform',
      'session_id',
      'version',
    ],
    fixed_data: {
      logged_in: 'yes',
    },
  },
  subscriptions_customer_clicked_learn_more: {
    event_name: 'subscriptions_customer_clicked_learn_more',
    event_action: 'subscriptions_customer_clicked_learn_more',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_confirmation,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'is_referral',
      'cc_available',
      'channel',
      'equal_installment',
      'order_downpayemnt_amount',
      'order_repayment_amount',
      'duration',
      'user_action',
      'platform',
      'session_id',
      'version',
    ],
    fixed_data: {
      logged_in: 'yes',
    },
  },
  subscriptions_customer_clicked_close_popup_benefits: {
    event_name: 'subscriptions_customer_clicked_close_popup_benefits',
    event_action: 'subscriptions_customer_clicked_close_popup_benefits',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_confirmation,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'is_referral',
      'cc_available',
      'channel',
      'equal_installment',
      'order_downpayemnt_amount',
      'order_repayment_amount',
      'duration',
      'user_action',
      'platform',
      'session_id',
      'version',
    ],
    fixed_data: {
      logged_in: 'yes',
    },
  },
  subscriptions_opt_in_banner_shown: {
    event_name: 'subscriptions_opt_in_banner_shown',
    event_action: 'subscriptions_opt_in_banner_shown',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_confirmation,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'is_referral',
      'cc_available',
      'channel',
      'equal_installment',
      'order_downpayemnt_amount',
      'order_repayment_amount',
      'duration',
      'user_action',
      'platform',
      'session_id',
      'version',
    ],
    fixed_data: {
      logged_in: 'yes',
    },
  },
  subscriptions_active_status_shown: {
    event_name: 'subscriptions_active_status_shown',
    event_action: 'subscriptions_active_status_shown',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_confirmation,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'is_referral',
      'cc_available',
      'channel',
      'equal_installment',
      'order_downpayemnt_amount',
      'order_repayment_amount',
      'duration',
      'user_action',
      'platform',
      'session_id',
      'version',
    ],
    fixed_data: {
      logged_in: 'yes',
    },
  },
  subscriptions_service_fee_shown: {
    event_name: 'subscriptions_service_fee_shown',
    event_action: 'subscriptions_service_fee_shown',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_confirmation,
    parameters: [
      'event_category',
      'event_action',
      'event_label',
      'logged_in',
      'language',
      'customer_id',
      'user_type',
      'device_type',
      'location_country',
      'page_type',
      'date_time',
      'currency_code',
      'merchant_id',
      'merchant_name',
      'merchant_country',
      'payment_type',
      'order_total_amount',
      'order_id',
      'is_referral',
      'cc_available',
      'channel',
      'equal_installment',
      'order_downpayemnt_amount',
      'order_repayment_amount',
      'duration',
      'user_action',
      'platform',
      'session_id',
      'version',
    ],
    fixed_data: {
      logged_in: 'yes',
    },
  },
  switch_plan_clicked: {
    event_name: 'switch_plan_clicked',
    event_action: 'switch_plan_clicked',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_options,
    parameters: DEFAULT_TRACKING_PARAMETERS,
    fixed_data: {
      logged_in: 'yes',
    },
  },
  si2_button_clicked: {
    event_name: 'si2_button_clicked',
    event_action: 'si2_button_clicked',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_options,
    parameters: DEFAULT_TRACKING_PARAMETERS,
    fixed_data: {
      logged_in: 'yes',
    },
  },
  si3_button_clicked: {
    event_name: 'si3_button_clicked',
    event_action: 'si3_button_clicked',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_options,
    parameters: DEFAULT_TRACKING_PARAMETERS,
    fixed_data: {
      logged_in: 'yes',
    },
  },
  si4_button_clicked: {
    event_name: 'si4_button_clicked',
    event_action: 'si4_button_clicked',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_options,
    parameters: DEFAULT_TRACKING_PARAMETERS,
    fixed_data: {
      logged_in: 'yes',
    },
  },
  ptd_learn_more_banner: {
    event_name: 'ptd_learn_more_banner',
    event_action: 'ptd_learn_more_banner',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_confirmation,
    parameters: ['order_downpayemnt_amount', ...DEFAULT_TRACKING_PARAMETERS],
    fixed_data: {
      logged_in: 'yes',
    },
  },
  ptd_equal_payment_banner: {
    event_name: 'ptd_equal_payment_banner',
    event_action: 'ptd_equal_payment_banner',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_confirmation,
    parameters: ['order_downpayemnt_amount', ...DEFAULT_TRACKING_PARAMETERS],
    fixed_data: {
      logged_in: 'yes',
    },
  },
  ptd_learn_more_close_button: {
    event_name: 'ptd_learn_more_close_button',
    event_action: 'ptd_learn_more_close_button',
    event_category: 'checkout',
    page_type: TRACKING_PARAM_PAGE_TYPE.checkout_payment_confirmation,
    parameters: ['order_downpayemnt_amount', ...DEFAULT_TRACKING_PARAMETERS],
    fixed_data: {
      logged_in: 'yes',
    },
  },
}

const TRACKING_EVENTS = Object.entries(TRACKING_CONFIGS).reduce(
  (res, [key, value]) => ({ ...res, [key]: value.event_name }),
  {}
)

export { TRACKING_PARAM_PAGE_TYPE, TRACKING_CONFIGS, TRACKING_EVENTS }
export default TRACKING_CONFIGS
